module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-06.f27ca4c5.png";